import { render, staticRenderFns } from "./RequestServices.vue?vue&type=template&id=a167b3da&scoped=true"
import script from "./RequestServices.vue?vue&type=script&lang=js"
export * from "./RequestServices.vue?vue&type=script&lang=js"
import style0 from "./RequestServices.vue?vue&type=style&index=0&id=a167b3da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a167b3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a167b3da')) {
      api.createRecord('a167b3da', component.options)
    } else {
      api.reload('a167b3da', component.options)
    }
    module.hot.accept("./RequestServices.vue?vue&type=template&id=a167b3da&scoped=true", function () {
      api.rerender('a167b3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/components/details/RequestServices.vue"
export default component.exports